export const terItem = (made, total) => ({
  textAlign: "left",
  position: "relative",
  cursor: "pointer",
  height: "100%",
  backgroundColor: made === total ? "#D7E6FF" : made > 0 ? "#CCEACA" : null,
});
